<!--
 * @Author: 
 * @Date: 2022-06-29 09:26:58
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-07-06 09:27:10
 * @FilePath: /Cup2Market/src/components/card/components/CardPrice.vue
 * @Description: 

data.actPrice
data.linePrice
data.partGoodsId,
oneTabBrandEveryPartId: data.partId,
data.saveProfit 
data.activityReward 

showCart: true,
 
-->
<template>
  <div class="amount">
    <div ref="myActPrice" class="left">
      <span class="prefix">¥</span>
      <span class="value">{{ data.actPrice }}</span>
      <!-- 划线价  小b不要 小c要 -->
      <del
        v-show="data.linePrice && !$store.state.user.distributionFlag"
        class="text-xxs text-gray center"
      >
        ¥{{ data.linePrice }}
      </del>
    </div>
    <!-- 购物车  小b不要 小c要-->
    <div
      v-show="!$store.state.user.distributionFlag"
      ref="myCart"
      class="mr-2 mb-1 cart-btn"
      @click.stop="
        $router.push({
          name: 'BrandPlaceGoodsDetail',
          params: {
            id: data.partGoodsId,
            oneTabBrandEveryPartId: data.partId,
            showCart: true,
          },
        })
      "
    >
      <cartIcon />
    </div>

    <!-- //暂时不用下面省赚的 -->
    <div ref="mySaveProfit" class="right van-ellipsis" v-distributor="true">
      <span class="label">省赚</span>
      <span class="value">
        {{ data.saveProfit }}
        <template v-if="data.activityReward === 'COMMISSION'">*2</template>
      </span>
    </div>
  </div>
</template>

<script>
import cartIcon from "@/components/TheCartIcon.vue";
export default {
  name: "CardPrice",
  components: { cartIcon },
  computed: {
    data: {
      get() {
        return this.$attrs.data;
      },
    },
    activityState: {
      get() {
        return this.$attrs.activityState;
      },
    },
  },
  watch: {
    activityState: function (newval, oldval) {
      this.updateColor(newval);
    },
  },
  mounted() {
    this.updateColor(this.activityState);
  },
  methods: {
    updateColor(state) {
      const refs = this.$refs;
      const ActPriceEl = refs.myActPrice;
      const CartEl = refs.myCart;
      const SaveProfitEl = refs.mySaveProfit;
    
      if (state === true) {
        // console.log(
        //   'ActPriceEl.classList.contains("pre-color")',
        //   ActPriceEl.classList.contains("pre-color")
        // );
        if (ActPriceEl.classList.contains("pre-color")) {
          [CartEl, ActPriceEl].forEach((el) => {
            el.classList.remove("pre-color");
          });
          SaveProfitEl.classList.remove("pre-right");
        }
      } else {
        [CartEl, ActPriceEl].forEach((el) => {
          el.classList.add("pre-color");
        });
        SaveProfitEl.classList.add("pre-right");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.amount {
  /* px-to-viewport-ignore-next */
  @price-height: 40px;
  /* px-to-viewport-ignore-next */
  height: @price-height;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  /* px-to-viewport-ignore-next */
  padding-top: 11px;
  .left {
    /* px-to-viewport-ignore-next */
    padding-top: 3px;
    .prefix {
      /* px-to-viewport-ignore-next */
      font-size: 18px;
      /* px-to-viewport-ignore-next */
      margin-right: 2px;
      /* px-to-viewport-ignore-next */
      line-height: 18px;
      font-weight: 800;
    }
    .value {
      /* px-to-viewport-ignore-next */
      font-size: 20px;
      /* px-to-viewport-ignore-next */
      line-height: 20px;
      font-weight: 800;
    }
    color: var(--sale-status-color);
  }

  .cart-btn {
    color: var(--sale-status-color);
  }
  .pre-color {
    color: var(--pre-sale-status-color);
  }

  .right {
    min-width: 156px;
    padding: 0 12px 0 18px;
    /* px-to-viewport-ignore-next */
    height: 26px;
    background: var(--sale-status-linear);
    border-radius: 200px 0px 12px 0px;
    /* px-to-viewport-ignore-next */
    font-size: 12px;
    font-weight: 600;
    color: #ffffff;
    /* px-to-viewport-ignore-next */
    line-height: 17px;
    text-align: center;
    /* px-to-viewport-ignore-next */
    padding-top: 5px;
  }
  .pre-right {
    background: var(--pre-sale-status-linear);
  }
}
</style>
